import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { T } from '@sm/intl';
import { createUseStyles } from 'react-jss';
import { Box } from '@wds/box';
import ErrorCard from '@sm/webassets/dist/components/ErrorCard';
import { Typography } from '@wds/typography';
export const COPY = {
  title: {
    id: 'OpenEndedCoding.FiveHundredError.title',
    defaultMessage: 'It looks like we slipped!',
    description: '[Type: Header][Vis: med] - OEC five hundred title'
  },
  description: {
    id: 'OpenEndedCoding.FiveHundredError.description',
    defaultMessage: 'Sorry about that! Please try refreshing the page. If this keeps happening, the issue may be on our end: <a href="https://surveymonkey.statuspage.io/" target="_blank">check our status page</a> for details.',
    description: '[Type: Header][Vis: med] - OEC five hundred description'
  }
};
const useStyles = createUseStyles(theme => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      margin: `${theme.spacing[7]}px ${theme.spacing[3]}px`
    }
  };
});
const FiveHundredError = ({
  title
}) => {
  const classes = useStyles();
  return _jsxs(Box, {
    className: classes.container,
    children: [_jsx(ErrorCard, {
      iconOnly: true
    }), _jsx(Box, {
      mt: 4,
      children: _jsx(Typography, {
        variant: "sectionTitle",
        align: "center",
        children: title !== null && title !== void 0 ? title : _jsx(T, {
          desc: COPY.title
        })
      })
    }), _jsx(Box, {
      mt: 5,
      mx: 3,
      children: _jsx(Typography, {
        variant: "body",
        align: "center",
        children: _jsx(T, {
          desc: COPY.description,
          html: true
        })
      })
    })]
  });
};
export default FiveHundredError;